import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import { asset } from "../../Services/BaseHelpers";
import PageHeader from "../../Components/Utilities/PageHeader";
import Section from "../../Components/Utilities/Section";
import { MailLink } from "../../Components/Utilities";
import QuestionSection from "../../Components/Utilities/QuestionSection";
import RegisterButton from "../../Components/Button/RegisterButton";
import { User } from "../../Services";

export default class Dashboard extends React.Component {

    render () {
        return (
            <Authenticated title="Dashboard">
                <PageHeader
                    title={"RETAILER CONVENTION 2023"}
                    subtitle={"Cape Town"}
                    imgSrc={'BMW-Homepage-Hero.png'}
                />
                {this.renderOpeningTextSection()}
                {this.renderOpeningEventSection()}
                {this.renderOpeningVideoSection()}
                {this.renderOpeningDeadlineSection()}
                {this.renderOpeningPicturesSection()}
            </Authenticated>
        );
    }

    renderOpeningTextSection () {
        let eventLink;

        switch( User.data?.groups[0]?.name ) {
            case 'HOB':
                eventLink =  'https://cvent.me/dXwmdP'
                break;
            case 'ICO':
            default:
                eventLink =  'https://cvent.me/QDl0RZ'
        }

        return (
            <Section>
                <p className={"bmw-bold text-2xl bmw-condenced-bold"}>
                    INVESTOR, OWNER AND FRANCHISE DIRECTORS: 25 APRIL TO 1 MAY
                    <br />
                    HEADS OF BUSINESS: 26 APRIL TO 2 MAY
                    <br/>
                    <span className={"bmw-light"}>
                        (All dates include travel)
                    </span>
                </p>

                <p className={"bmw-light"}>
                    Chris Brownridge and the Management Committee are very much looking forward to welcoming you to Cape Town for the BMW Group UK Retailer Convention this coming April.
                </p>
                <p className={"bmw-light"}>
                    This Convention will set out the future ahead, the strategic outlook and direction for all of our businesses.
                </p>
                <p className={"bmw-light"}>
                    Please take a moment to watch the teaser film and then read some of the highlights to what is set to be an exceptional trip and a key milestone for our future.
                </p>
                <p className={"bmw-bold"}>
                    You are required to formally register your attendance, for both you and your guest, before 17:00 Friday 24 February.
                </p>
                <div className={"pt-3"}>
                    <a href={eventLink} target={"_blank"} className={"pt-4"}>
                        <RegisterButton text="Register Now" />
                    </a>
                </div>
            </Section>
        )
    }
    renderOpeningEventSection () {
        return (
            <div className="bg-event">
                <Section>
                    <div className={"flex flex-row text-white text-left"}>
                        <div className={"my-auto mx-auto w-2/3 bmw-condenced-regular"}>
                            <p className={"text-lg"}>
                                The Event
                            </p>
                            <p className={"text-sm pb-4"}>
                                The BMW Group UK Convention will set out the strategic vision for our businesses.
                            </p>
                            <p className={"text-lg"}>
                                The Location
                            </p>
                            <p className={"text-sm"}>
                                We have chosen South Africa to host this event as they have already gone through the Future Sales Model changes.
                                With experts on hand, it’ll offer a unique insight into how their business has changed and the adaptions that
                                have been made.
                                Whether you’re a first time visitor to Cape Town or well-acquainted with this multifaceted city,
                                we have a schedule filled with exclusive experiences to showcase everything this incredible destination has to offer!

                            </p>
                        </div>
                        <div className={"my-auto mx-auto w-1/3"}>
                            <img className={"my-auto mx-auto "} src={ asset ( 'images/event_logo.png' ) } />
                        </div>
                    </div>
                </Section>
            </div>
        )
    }
    renderOpeningVideoSection () {
        return (
            <Section>
                    <p className={"text-2xl bmw-condenced-bold"}>
                        INTERESTED?
                    </p>
                    <p className={"bmw-condenced-bold"}>
                        Here’s a sneak peek of what’s in store…
                    </p>
                    <iframe
                        src={"https://player.vimeo.com/video/794162518?h=1f5a6d289d"}
                        className="my-4 md:my-12 h-full w-full mx-auto px-2 md:px-6 rounded-lg h-96"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                    />
                    <p className={"bmw-condenced-bold text-2xl pt-6"}>
                        SECURE YOUR PLACE
                    </p>
                    <p className={"bmw-condenced-bold"}>
                        Want to be at the BMW Group UK Retailer Convention 2023 in Cape Town, South Africa?
                        Here’s what you need to do:
                    </p>
                    <div className={"grid grid-cols-1 lg:grid-cols-4 gap-5 bmw-light text-sm"}>
                        <div>
                            <p className={"text-center text-xl"}>1.</p>
                            Please formally register your attendance, for both you and your guest, before Friday 24 February.
                        </div>
                        <div>
                            <p className={"text-center text-xl"}>2.</p>
                            Look out for further information and updates regarding hotels and flights. You’ll have a
                            dedicated BMW UK Events Team on hand to help with confirming your arrangements.
                        </div>
                        <div>
                            <p className={"text-center text-xl"}>3.</p>
                            You’ll receive a personalised travel agenda and access to the ‘Retailer Convention app’
                            before travel to ensure you have all the information you need before departure.
                        </div>
                        <div>
                            <p className={"text-center text-xl"}>4.</p>
                            Pack your bags and grab your passports. We look forward to seeing you in Cape Town in April!
                        </div>
                    </div>
                </Section>
        )
    }
    renderOpeningDeadlineSection () {
        return (
            <div className="bg-deadline">
                <Section>
                    <img className={"mx-auto my-auto"} src={ asset ( 'images/clock.png' ) } />
                    <p className={"bmw-condenced-bold text-2xl text-white uppercase"}>
                        Deadline
                    </p>
                    <p className={"bmw-condenced-bold text-white text-sm"}>
                         Remember to register by Friday 24 February 2023 to secure your place!
                    </p>
                </Section>
            </div>
        )
    }
    renderOpeningPicturesSection () {
        return (
            <Section>
                <div className={"grid grid-cols-1 lg:grid-cols-3 gap-4"}>
                    <div>
                        <img className={"mx-auto my-auto"} src={ asset ( 'images/cable_car.png' ) } />
                    </div>
                    <div>
                        <img className={"mx-auto my-auto"} src={ asset ( 'images/waterfront_convention.png' ) } />
                    </div>
                    <div>
                        <img className={"mx-auto my-auto"} src={ asset ( 'images/hout_bay.png' ) } />
                    </div>
                </div>
                <QuestionSection />
            </Section>
        )
    }
}
